import { registerPlugin } from '@capacitor/core';
const AppsFlyer = registerPlugin('AppsFlyerPlugin', {});
export * from './definitions';
export * from './Appsflyer_constants';
export * from './appsflyer_interfaces';
export { AppsFlyer };
